import { render, staticRenderFns } from "./second.vue?vue&type=template&id=c607cad4&scoped=true"
import script from "./second.vue?vue&type=script&lang=js"
export * from "./second.vue?vue&type=script&lang=js"
import style0 from "./second.vue?vue&type=style&index=0&id=c607cad4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c607cad4",
  null
  
)

export default component.exports